export default {"src":"/_next/static/media/empty-state-discussions.65b21c46.svg","height":94,"width":127,"blurWidth":0,"blurHeight":0};